import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';
import {MultiSelect} from '../../../../../common/newSelect';
import {stepName} from '../../../config/nodeCategories';
import type {NodeEditorV2Props} from '../types';
import useTeamEmailSteps from './useTeamEmailSteps';

/**
 * Send team email's identity-panel controls over the dialog's draft: who gets the email and which files go with it,
 * so the editor beside it is the email itself (subject and content).
 */
export default function SendTeamEmailIdentityAside(props: NodeEditorV2Props) {
    const {setNodeConfig, flowNodes = [], readOnly} = props;
    const {t} = useTranslation();
    const {teamStep, attachmentSources, attachmentIds} = useTeamEmailSteps(props);

    return <Stack gap={3} sx={{minWidth: 0}}>
        <Stack gap={0.5}>
            <Typography variant={'body2'} fontWeight={500} color={'text.secondary'}>{t('Recipient')}</Typography>
            <Typography variant={'body1'}>{teamStep
                ? t('Each team member selected in ‘{{step}}’ gets their own email.', {step: stepName(teamStep)})
                : t('Nobody yet: only a step below Team members has a team member to write to.')}</Typography>
        </Stack>
        <Stack gap={0.5}>
            <MultiSelect label={t('Attach files from')} placeholder={t('No attachments')} value={attachmentIds}
                         options={attachmentSources.map(node => ({value: node.id, label: stepName(node)}))}
                         unknownLabels={Object.fromEntries(flowNodes.map(node => [node.id, stepName(node)]))}
                         loading={false} disabled={readOnly}
                         onChange={value => setNodeConfig(previous => ({...previous, attachmentSourceNodeIds: value}))}/>
            <Typography variant={'body2'} color={'text.secondary'}>
                {t('Every file from the selected steps is attached. If any file is unavailable, the email is not sent.')}
            </Typography>
        </Stack>
    </Stack>;
}
